import { useIsMobile } from '~/context/common/DeviceContext';
import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';

export default function useShowPageNavigation() {
  const shouldRenderCondensedHero = useShouldRenderCondensedHero();
  const isMobile = useIsMobile();

  return !shouldRenderCondensedHero && !isMobile;
}
